import { P } from '../../styles/theme';

export default function Badge({ children, color = P.rose }) {
  return (
    <span style={{
      background: color + '20', color,
      padding: '3px 10px', borderRadius: '20px',
      fontSize: '11px', fontWeight: 700,
    }}>
      {children}
    </span>
  );
}
